<template>
  <div id="app">
    <div class="faqs">
      <Index
        v-for="(faq, i) in faqs"
        :faq="faq"
        :index="i"
        :key="i"
        :open="faq.open"
        @toggleOpen="toggleOpen"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Index from "./index";
export default {
  name: "app",
  components: {
    Index,
    laccordion: () => import("@/components/learner/accordion/container"),
  },
  data() {
    return {
      faqs: [
        // {
        //   question: "Who is the best Superhero?",
        //   answer: "I'm not sure but we love him 3000",
        //   open: false,
        // },
        // {
        //   question: "What is Goku's form called with White Hair?",
        //   answer: "Mastered Ultra Instinct",
        //   open: false,
        // },
        // {
        //   question: "Have you liked & subscried yet?",
        //   answer: "YES",
        //   open: false,
        // },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchLearnerNewCourse"]),
    navigate() {
      this.$router.push(`/learner/courses/${this.$route.params.id}/modules`);
    },
    toggleOpen: function(index) {
      this.faqs = this.faqs.map((faq, i) => {
        if (index === i) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }
        return faq;
      });
    },
  },
  computed: {
    ...mapGetters(["getLearnerNewCourse"]),
  },
  async created() {
    await this.fetchLearnerNewCourse({
      id: this.$route.params.id,
    });
    let data = [];
    this.getLearnerNewCourse.modules.forEach((module) => {
      let obj = {};
      obj.title = module.title;
      obj.description = module.description;
      obj.open = false;
      obj.lessons = module.lessons;
      data.push(obj);
    });
    this.faqs = data;
    //console.log(this.getLearnerNewCourse);
    //console.log(this.faqs);
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  background-color: #eee;
}
header {
  background-color: #3c3c3c;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
}
header h1 {
  color: #eee;
  font-size: 28px;
  font-weight: 300;
  text-transform: uppercase;
}
header h1 span {
  color: #0984e3;
  font-weight: 900;
}
.faq {
  display: block;
  width: 100%;
  padding: 15px;
  border-radius: 2px;
  margin: 5px 0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  background-color: #fff;
}
.faq .question {
  position: relative;
  color: #3c3c3c;
  font-size: 13px;
  transition: all 0.4s linear;
}
.faq .question::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%) rotate(0deg);
  /* width: 30px;
  height: 30px; */
  /* background-image: url("./arrow-down-mint.svg"); */
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  transition: all 0.2s linear;
}
.faq.open .question {
  margin-bottom: 15px;
}
.faq.open .question::after {
  transform: translateY(-50%) rotate(90deg);
}
.faq .answer {
  color: #3c3c3c;
  font-size: 12px;
  opacity: 0;
  max-height: 0px;
  overflow-y: hidden;
  transition: all 0.4s ease-out;
}
.faq.open .answer {
  opacity: 1;
  max-height: 1000px;
}
</style>
